export const productionLineFr = {
    title: 'Lignes de production',
    list: 'Liste des lignes de production',
    detail: 'Détail du ligne de production',
    create: 'Créer un ligne de production',
    delete: 'Supprimer le ligne de production',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce ligne de production ?',
    columns: {
        id: 'ID',
        name: 'Nom',
        actions: 'Actions'
    },
    model: {
        name: 'Nom du ligne de production',
        organization: 'Organisation'
    },
    errors: {
        fetchFailed: 'Impossible de charger les lignes de production',
        createFailed: 'Impossible de créer le ligne de production',
        updateFailed: 'Impossible de mettre à jour le ligne de production',
        deleteFailed: 'Impossible de supprimer le ligne de production'
    },
    success: {
        created: 'Ligne de production créé avec succès',
        updated: 'Ligne de production mis à jour avec succès',
        deleted: 'Ligne de production supprimé avec succès'
    }
}
